import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App.js';
import { ErrorBoundary } from './components/ErrorBoundary.js';
import { PaintsProvider } from './chat/use-paints.js';
import { PreferencesProvider } from './chat/use-preferences.js';
import { SessionProvider } from './auth/session-context.js';
import './styles/base.css';

const container = document.getElementById('root');

if (container === null) {
  throw new Error('Connaro Console failed to mount: #root element is missing.');
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      {/*
       * The backstop. AppShell has its own boundary so a page crash keeps the
       * navigation, but the shell, RequireAuth, the OBS dock and the session
       * provider all render OUTSIDE it — and a failure there is exactly the
       * one that would otherwise blank the whole document.
       */}
      <ErrorBoundary surface="the Console">
        <SessionProvider>
          <PreferencesProvider>
            <PaintsProvider>
              <App />
            </PaintsProvider>
          </PreferencesProvider>
        </SessionProvider>
      </ErrorBoundary>
    </BrowserRouter>
  </StrictMode>,
);
